<template>
  <div>
    <div v-if="loadingData">
      <v-row class="text-center" align="center" justify="center">
        <v-progress-circular
          :indeterminate="true"
          :rotate="0"
          :size="32"
          :width="4"
          color="light-blue"
        ></v-progress-circular>
      </v-row>
      <v-row class="text-center" align="center" justify="center">
        Caricamento in corso....
      </v-row>
    </div>

    <div v-if="!loadingData">
      <v-row class="form-title" align="center" justify="center"
        ><h2 class="header-title-h2">
          Grazie per il suo tempo. La procedura guidata è terminata...
        </h2></v-row
      >
      <v-row class="form-title" align="center" justify="center">
        <h4>
          Le ricordiamo che può modificare i contenuti successivamente in modo
          autonomo. Se invece volesse cambiare l'aspetto del suo sito o il suo
          piano di iscrizione, la invitiamo ad effettuarlo immediatamente
          navigando indietro nel Wizard, utilizzando la barra superiore. Una
          volta completata la procedura, non sarà più possibile modificare l'
          aspetto o il piano di iscrizione, mentre i contenuti saranno sempre
          modificabili in completa autonomia dalla sua area riservata.
        </h4>
        <h4>
          <b>
            Le ricordiamo inoltre che prima di procedere al pagamento, può
            visualizzare un anteprima finale del suo sito utilizzando l'apposito
            bottone.</b
          >
        </h4>
      </v-row>
    </div>

    <div class="form-spacer" />

    <v-row class="text-center" align="center" justify="center">
      <v-col>
        <v-btn
          v-if="!proceedPayment"
          class="ml-2 white--text"
          @click="previewSite($event)"
          color="#b083a8" 
        >
          Anteprima sito
        </v-btn>
      </v-col>
    </v-row>


<div style='height:20px'/>

    <v-row class="text-center" align="center" justify="center">
      <v-btn
        v-if="!proceedPayment"
        class="ml-2"
        @click="goBack()"
        color="primary"
        >Indietro</v-btn
      >
      
      
      <v-btn
        v-if="!proceedPayment"
        class="ml-2"
        @click="moveToPayment($event)"
        color="secondary"
      >
        Procedi con il pagamento
      </v-btn>

      <v-progress-circular
        v-if="proceedPayment"
        :indeterminate="true"
        :rotate="0"
        :size="32"
        :width="4"
        color="light-blue"
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<style scoped>
.header-title-h2 {
  color: #74a2bc;
  font-size: 32px;
  font-weight: 400;
}

.form-title {
  color: gray;
  font-size: 20px;
  margin: 10px;
}

.form-title-sub {
  color: gray;
  font-size: 16px;
  margin: 10px;
}

.form-title-sub-mini {
  color: gray;
  font-size: 14px;
  margin: 10px;
}

.form-content {
}

.service-row {
  background-color: #f5f5f5;
  font-size: 18px;
  margin-left: 2px;
  margin-right: 2px;
}

.service-card {
  padding: 5px;
}

.form-spacer {
  height: 30px;
}

.service-check {
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>

<script>
import store from "../../store";
import config from "../../config";

export default {
  data() {
    return {
      loadingData: true,
      services: [],
      proceedPayment: false,
    };
  },

  mounted() {
    this.loadingData = false;
  },

  methods: {
    moveToPayment() {
      this.proceedPayment = true;
      let completedStep = this.$store.state.wizard.completedStep;
      if (completedStep < this.$store.state.wizard.selectedStep)
        completedStep = this.$store.state.wizard.selectedStep;

      store
        .dispatch("setWizardSteps", {
          completedStep: completedStep,
          selectedStep: this.$store.state.wizard.selectedStep + 1,
          meta: {},
        })
        .then(() => {
          this.proceedPayment = false;
        });
    },

    goBack() {
      this.$store.state.wizard.selectedStep--;
    },

    previewSite() {
      let thisURl = window.location.origin;
      let url =
        thisURl +
        "/sites/"+config.appPath + "/"+this.$store.state.wizard.meta.feature+"?s=" +
        this.$store.state.wizard.build_state_id;
      window.open(url.replace("/deluxe","/premium"));
    },
  },
};
</script>
